import { render, staticRenderFns } from "./communityEdit.vue?vue&type=template&id=188ba9c8&scoped=true"
import script from "./communityEdit.vue?vue&type=script&lang=js"
export * from "./communityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ba9c8",
  null
  
)

export default component.exports